var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpNext = function SvgUpNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 94 94"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#223838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M47 91.56c24.853 0 45-20.147 45-45s-20.147-45-45-45-45 20.148-45 45c0 24.853 20.147 45 45 45M24.602 67.56l43.2-40.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#223838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M27.302 27.06h40.5v40.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ED5321",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M8 24.096C15.776 10.626 30.332 1.56 47 1.56c24.852 0 45 20.148 45 45 0 8.196-2.19 15.882-6.018 22.5"
  })));
};
export default SvgUpNext;